module.exports = __webpack_public_path__ + "static/media/info.174b1592.svg";